// extracted by mini-css-extract-plugin
export default {"active":"LanguagePicker_active__VWHZR","image":"LanguagePicker_image__+UVdx","head":"LanguagePicker_head__bVMHG"};